(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection__modern"]) return;
  try {
    
  if (Shopify.designMode) {
    // Close overlay-drawer when any section is selected in theme editor
    document.addEventListener('shopify:section:select', function() {
      const overlayDrawer = document.querySelector('overlay-drawer');
      if (overlayDrawer) overlayDrawer.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    
(function () {
  /**
   * Submit to Mailchimp via JSONP against /subscribe/post-json.
   * This is Mailchimp's officially supported AJAX pattern — it works
   * cross-origin and returns a real {result: 'success'|'error', msg: '...'}
   * object so we can surface actual errors instead of fake successes.
   */
  function mailchimpJsonp(actionUrl, fields, honeypotName) {
    return new Promise(function (resolve, reject) {
      var jsonUrl = actionUrl.replace('/subscribe/post', '/subscribe/post-json');

      var params = [];
      Object.keys(fields).forEach(function (k) {
        params.push(encodeURIComponent(k) + '=' + encodeURIComponent(fields[k]));
      });
      if (honeypotName) {
        params.push(encodeURIComponent(honeypotName) + '=');
      }

      var cbName = 'nsMcCb_' + Date.now() + '_' + Math.floor(Math.random() * 1e6);
      params.push('c=' + cbName);

      var fullUrl = jsonUrl + (jsonUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
      var script = document.createElement('script');

      var timeoutId = setTimeout(function () {
        cleanup();
        reject(new Error('Mailchimp request timed out'));
      }, 10000);

      function cleanup() {
        clearTimeout(timeoutId);
        try { delete window[cbName]; } catch (e) { window[cbName] = undefined; }
        if (script.parentNode) script.parentNode.removeChild(script);
      }

      window[cbName] = function (response) {
        cleanup();
        resolve(response || { result: 'error', msg: 'Empty response from Mailchimp' });
      };

      script.onerror = function () {
        cleanup();
        reject(new Error('Mailchimp script failed to load'));
      };

      script.src = fullUrl;
      document.head.appendChild(script);
    });
  }

  function initForm(form) {
    if (!form || form.dataset.nsInitialized === '1') return;
    form.dataset.nsInitialized = '1';

    var mcUrl      = form.dataset.mailchimpUrl || '';
    var zapUrl     = form.dataset.zapierUrl || '';
    var honeypot   = form.dataset.honeypotName || '';
    var msgSuccess = form.dataset.msgSuccess || 'Thanks!';
    var msgError   = form.dataset.msgError || 'Something went wrong.';
    var msgSubmit  = form.dataset.msgSubmitting || 'Submitting...';

    var submitBtn  = form.querySelector('.ns-submit');
    var messageEl  = form.querySelector('.ns-message');

    function setMessage(text, kind) {
      if (!messageEl) return;
      messageEl.textContent = text || '';
      messageEl.className = 'ns-message' + (kind ? ' is-' + kind : '');
    }

    function collectFields() {
      var data = {};
      var inputs = form.querySelectorAll('[data-ns-field]');
      for (var i = 0; i < inputs.length; i++) {
        var el = inputs[i];
        var name = el.getAttribute('name');
        if (!name) continue;
        if (el.type === 'checkbox') {
          var checkedVal = el.getAttribute('data-checked-value') || 'Y';
          var uncheckedVal = el.getAttribute('data-unchecked-value') || 'N';
          data[name] = el.checked ? checkedVal : uncheckedVal;
        } else {
          data[name] = (el.value || '').toString().trim();
        }
      }
      return data;
    }

    function fireZapier(fields, mcResult) {
      if (!zapUrl) return Promise.resolve(null);
      var payload = Object.assign({}, fields, {
        submitted_at:      new Date().toISOString(),
        source_url:        window.location.href,
        page_title:        document.title,
        mailchimp_result:  mcResult ? mcResult.result : 'unknown',
        mailchimp_message: mcResult && mcResult.msg != null ? mcResult.msg : ''
      });
      // Use application/x-www-form-urlencoded to avoid a CORS preflight.
      // Zapier's Catch Hook doesn't respond to OPTIONS preflights, so a
      // JSON POST from the browser would be blocked. Form-encoding is a
      // "simple request" — no preflight, and Zapier parses the body the
      // same way (each key becomes a top-level field on the payload).
      var body = new URLSearchParams();
      Object.keys(payload).forEach(function (k) {
        body.append(k, payload[k] == null ? '' : String(payload[k]));
      });
      return fetch(zapUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      }).catch(function (err) {
        console.error('[newsletter-signup] Zapier error:', err);
        return null;
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      submitBtn.disabled = true;
      setMessage(msgSubmit, '');

      var fields = collectFields();
      var mcConfigured = mcUrl && mcUrl.indexOf('list-manage.com') !== -1;

      console.log('[newsletter-signup] Mailchimp URL:', mcUrl || '(not set)');
      console.log('[newsletter-signup] Honeypot field name:', honeypot || '(none)');
      console.log('[newsletter-signup] Submitting fields:', fields);
      if (!mcConfigured) {
        console.warn('[newsletter-signup] Mailchimp URL is missing or does not look like a list-manage.com URL — submission to Mailchimp will be SKIPPED. Configure it in Theme Editor > section settings.');
      }

      var mcPromise = mcConfigured
        ? mailchimpJsonp(mcUrl, fields, honeypot).catch(function (err) {
            console.error('[newsletter-signup] Mailchimp error:', err);
            return { result: 'error', msg: (err && err.message) || 'Mailchimp request failed' };
          })
        : Promise.resolve({ result: 'skipped', msg: 'Mailchimp URL not configured' });

      mcPromise
        .then(function (mcResult) {
          console.log('[newsletter-signup] Mailchimp response:', mcResult);
          // Fire Zapier regardless so the lead is captured even on Mailchimp failure.
          return fireZapier(fields, mcResult).then(function () { return mcResult; });
        })
        .then(function (mcResult) {
          var result = mcResult && mcResult.result;
          var msg    = mcResult && mcResult.msg;

          if (result === 'success') {
            setMessage(msgSuccess, 'success');
            form.reset();
          } else if (result === 'error' && msg && /already subscribed/i.test(msg)) {
            // Already-subscribed is a friendly success — still reset the form.
            setMessage(msgSuccess, 'success');
            form.reset();
          } else if (result === 'error' && msg) {
            // Surface the actual Mailchimp error (invalid email, etc.).
            // Strip any HTML Mailchimp may have included.
            var clean = msg.replace(/<[^>]*>/g, '');
            setMessage(clean, 'error');
          } else if (result === 'skipped') {
            // No Mailchimp configured — Zapier capture still happened.
            setMessage(msgSuccess, 'success');
            form.reset();
          } else {
            setMessage(msgError, 'error');
          }
        })
        .catch(function (err) {
          console.error('[newsletter-signup] Submit error:', err);
          setMessage(msgError, 'error');
        })
        .then(function () {
          submitBtn.disabled = false;
        });
    });
  }

  function initAll(root) {
    var forms = (root || document).querySelectorAll('form.ns-form');
    for (var i = 0; i < forms.length; i++) initForm(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init when section is reloaded in the Theme Editor
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
